import React from 'react'
// libs
import styled from 'styled-components'
// components
import { Scrollbar } from 'components/UI'
import { Chip as ChipOrigin, Grid2 as Grid } from '@mui/material'
// themes
import { colors } from 'themes'
import DotsIconOrigin from '@mui/icons-material/MoreHorizOutlined'
// constants
import { REVIEW_STATUSES } from 'constants/review'
// utils
import { size, transparentize } from 'polished'

// types
interface IChipProps {
  isDueToday: boolean
  isDueLate: boolean
}

interface ICardHeaderProps {
  backgroundColor?: string
  reviewStatus?: string
}

const CardWrapper = styled('div')`
  background: ${colors.white100};
  border-radius: 4px;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.2),
    0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 0 0 0 rgba(0, 0, 0, 0.12);
  margin-bottom: 16px;
`

const CardHeader = styled('div')<ICardHeaderProps>`
  align-items: center;
  background: ${({ backgroundColor }) => backgroundColor || colors.darkBlue500};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  color: ${colors.white100};
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  width: 100%;

  ${({ reviewStatus }) => reviewStatus !== REVIEW_STATUSES.NOT_STARTED && 'cursor: pointer'};
`

const CardText = styled('div')`
  font-size: 18px;
  font-weight: 600;
`

const DotsIcon = styled(DotsIconOrigin)`
  && {
    cursor: pointer;
    margin-left: auto;
    margin-top: auto;
    z-index: 8;

    ${size('24px')};
  }
`

const MenuItem = styled('div')`
  color: ${colors.blue500};
  cursor: pointer;
  font-weight: 500;
  padding: 5px 15px;
  text-align: left;

  &:hover {
    background-color: ${colors.gray230};
  }
`

const CardInnerWrapper = styled(({ isReviewComplete, ...props }) => <Grid {...props} />)<{ isReviewComplete: boolean }>`
  width: 100%;
  padding: 16px;
  position: relative;
  height: ${({ isReviewComplete }) => (isReviewComplete ? '100px' : '136px')};
`

const Chip = styled(({ isDueToday, isDueLate, isReviewComplete, ...props }) => <ChipOrigin {...props} />)<IChipProps>`
  && {
    background-color: ${colors.gray850};
    border-radius: 25px;
    color: ${colors.white};
    font-weight: 500;
    height: 35px;
    
    ${({ isDueToday, isReviewComplete }) => isDueToday && !isReviewComplete && `background-color: ${colors.orange300}`}
    ${({ isDueLate, isReviewComplete }) => isDueLate && !isReviewComplete && `background-color: ${colors.red300}`}
    ${({ isReviewComplete }) => isReviewComplete && `background-color: ${colors.green500}`}
`

const ViewButtonWrapper = styled('div')`
  align-items: center;
  background: ${transparentize(0.2, colors.white)};
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`

const Wrapper = styled((props) => <Scrollbar {...props} />)`
  height: 100%;
  padding: 16px 32px 16px 16px;
  width: 100%;
`

export { CardHeader, CardInnerWrapper, CardText, CardWrapper, Chip, DotsIcon, MenuItem, ViewButtonWrapper, Wrapper }
